import React from "react";
import { Card, makeStyles } from "@material-ui/core";
import LanguageBtn from "../LanguageBtn/LanguageBtn";
import "./AuthWrapper.scss";

const useStyles = makeStyles({
  root: {
    padding: "1rem 3rem" ,
    boxShadow: "unset",
    // width: "50%",
  },
});

export const AuthWrapper = ({ header, content, handleSubmit }) => {
  const classes = useStyles();
  return (
    <div className="authWrapper d-flex justify-content-center align-items-center">
      <div className="authWrapper_container">
        <div className="authWrapper_container_img" />
        <Card className={classes.root + " authWrapper_container_form-wrapper"}>
          <div className="">
            <LanguageBtn color={"text-dark"} />
          </div>
          {content}
        </Card>
      </div>
    </div>
  );
};
